import { render, staticRenderFns } from "./TrainerCreate.vue?vue&type=template&id=6ddb3cb8&"
import script from "./TrainerCreate.vue?vue&type=script&lang=js&"
export * from "./TrainerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainerCreate.vue"
export default component.exports